var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTram = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 302,
    viewBox: "0 0 150 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.6493 236.473V243.918",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2641 236.732V242.696",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7829 245.68V245.682",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0105 68.5422L74.0109 67.6404",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0109 69.4441L74.0105 68.5423",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.538 11.8221V13.325",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5182 235.569V243.846",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4476 296.526H40.4714",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4715 297.923H40.4515",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2675 282.625V284.066",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6277 282.989L40.6277 282.625",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81534 242.61V239.405",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8396 256.327L13.3933 244.979",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3777 292.262L21.6147 294.111",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58365 256.327V266.768",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4683 13.3251V7.31277",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1576 235.569L28.1576 244.388",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0089 70.3466L74.009 70.2716",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1653 244.937V235.57",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2588 246.154V246.152",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6537 246.102V246.1",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3146 245.725V245.727",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5429 7.31287V2.80378",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9206 12.3719H75.0416",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0416 60.7272H69.8336",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1704 121.543V120.04",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0845 235.569V244.585",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26922 285.899L8.11703 285.755",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0416 285.899H66.8767",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M50.461 284.058V282.625",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9381 282.99V282.625",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5453 282.625L39.5459 284.508",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7021 282.625L40.7021 282.989",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1.87659 239.144V223.094",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72472 123.071L6.72449 123.069",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0416 120.04H73.3827",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0415 66.7386H70.5687",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8951 118.078L23.1788 118.078L23.0043 118.078V123.069L41.3234 123.073L41.5422 123.071L68.046 123.073V121.543",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4256 292.262L21.6147 294.111L22.0522 294.657L16.8152 292.807L16.3777 292.262L16.3903 285.899L16.3911 285.464L33.1182 284.774L33.236 284.769L33.5624 284.755L33.5757 284.755L33.5732 282.625",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0043 123.069L22.1629 123.068L21.3469 123.069L21.3434 123.069",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54418 147.107L1.87662 142.714L3.6493 132.893L5.422 123.073L6.19785 123.071L6.20097 123.071L6.37467 123.07L6.3798 123.071",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M68.046 123.073H75.0416",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5757 284.755L33.9083 284.741L34.2391 284.727L34.3799 284.722L34.6618 284.71",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3234 123.073H41.5422V121.543L41.5721 121.543L60.8951 121.543",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3443 284.393L44.5392 284.302L50.2676 284.066L50.3162 284.064L50.3221 284.064L50.3423 284.063L50.3528 284.063L50.3886 284.061L50.4166 284.06L50.461 284.058L66.4431 283.399L66.8806 283.944L66.8767 285.899L66.863 292.808",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8396 266.768L15.2565 282.625L24.9408 282.625H32.7063L33.1162 282.625H55.099L65.3813 282.625H75.0416",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4431 283.399L66.4256 292.262L66.863 292.808L43.5887 293.768L43.5828 293.768L43.5777 293.768L43.5495 293.77L43.5376 293.77L43.5273 293.771L43.5032 293.772L43.4823 293.772L43.4767 293.773L43.4718 293.773L42.2391 293.824L42.233 293.824L42.2281 293.824L42.1999 293.825L42.1876 293.826L42.1777 293.826L42.1527 293.827L42.1327 293.828L42.1268 293.828L42.1221 293.828L40.5005 293.895L40.4792 293.896L40.4767 293.896L40.4715 293.897L40.4424 293.898L39.7226 293.928L39.554 293.934L36.7921 294.048L34.6712 294.136L22.0522 294.657",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55006 123.071L6.55033 123.07L6.37979 123.071H6.84436L8.38233 123.073",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1162 282.625L33.1164 283.196V283.27L33.1168 283.688V283.694L33.1171 284.005L33.1172 284.009L33.1173 284.116V284.118L33.1177 284.508L33.1182 284.774",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9732 246.561L47.2617 246.586V246.583L46.9732 246.561ZM46.9732 246.561L44.0921 246.312L43.1977 246.235L42.2588 246.154L41.6538 246.102L37.3147 245.725L36.7829 245.68L34.7493 245.504H34.7277L33.9641 245.438L33.1171 245.363V245.365",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M39.554 293.934L39.5586 296.27V296.273L39.5608 297.352L39.5664 298.795V298.798L39.5697 299.665L39.5697 299.667L39.5713 300.065L39.583 301H40.4715L40.4686 300.766",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0061 76.3522H72.7968L72.7965 76.1763L72.7962 76.0159V76.0002L72.796 75.5751V75.5554L72.7961 75.15L72.7961 75.0793L72.7962 74.9739L72.7997 70.3459L72.7999 70.1042L72.8004 69.4441L72.801 68.5423L72.8017 67.6404",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4827 299.464L40.483 299.842L40.4831 300.065L40.4826 300.111L40.4773 300.532L40.4756 300.668L40.4744 300.766L40.4714 301",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5091 282.625L40.509 282.685L40.5089 282.989L40.5085 284.293L40.5085 284.469",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76501 123.069L6.76464 123.071L6.84477 123.069L6.76501 123.069ZM6.76501 123.069L6.73592 123.071L6.72447 123.069L6.55861 123.071L6.55032 123.07",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0415 47.7481H68.2465H67.6139L66.9272 47.9897L67.6964 48.4227L67.8037 48.6499L68.3007 49.3266L68.3554 49.5517L68.5531 50.2556L68.5773 50.4535L68.6581 51.1137L68.6876 51.3553",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6611 282.625L34.6616 283.989L34.6616 284.093L34.6618 284.71L37.0765 284.61L39.546 284.508L39.9366 284.492L40.4345 284.472L40.4731 284.47L40.4752 284.47L40.4769 284.47L40.5085 284.469L40.6054 284.465L42.3443 284.393V282.99H40.9381L40.702 282.989H40.4781",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3857 234.276L53.6285 234.276H55.6308L64.2626 234.276H75.0416",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7997 70.3459H71.6461L71.7687 108.016",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0131 70.2722L74.0135 70.3459L74.0089 70.3466L74.0065 74.9944L74.0054 75.0793L74.006 75.2745L74.0052 75.5554L74.0058 75.7307L74.0055 76.0159L74.0063 76.0958",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0054 76.0159L74.0081 76.0958L74.007 76.1558L74.006 76.3522L74.0076 76.3834L74.0068 76.4852H72.7976L72.7968 76.3522",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2916 11.822H47.571V7.31284L47.6358 7.3127L48.2916 7.31287",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1988 11.822V7.31287H50.5429L50.538 7.3127L50.4733 7.31287L50.4683 7.3127L50.4683 2.80378",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61794 238.726L2.83808 238.725L1.87657 239.144L1.27762 239.405L2.81535 239.405L4.61794 238.726ZM4.61794 238.726V243.29L2.99268 243.29H2.83808L1.87657 242.871L1.87655 256.082V266.768",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3251 282.625L15.2565 282.625L8.11702 285.755L7.78548 285.901",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1.27762 239.405V242.61L1.87657 242.871",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1.87657 226.79L1.625 226.084L1.62442 226.046L1.62387 225.931L1.6234 225.75L1.62305 225.513L1.62282 225.238L1.62274 224.942L1.62282 224.647L1.62305 224.371L1.6234 224.135L1.62387 223.953L1.62442 223.839L1.625 223.8L1.87657 223.094L1.87663 142.714",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4722 282.989H40.434L40.4339 282.625",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0415 256.327H74.9831L74.9589 256.327L64.274 256.327L63.2136 256.327L53.656 256.327L51.5886 256.327L43.2178 256.327L40.2006 256.327L33.0463 256.327L29.1641 256.327L23.2263 256.327L18.5896 256.327L13.8396 256.327L8.58363 256.327L1.87653 256.327",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1576 244.937L24.1715 244.593L24.0846 244.585L23.1845 244.508L15.5183 243.846H15.5156L15.5183 235.569L23.1529 235.569H24.8983L28.1577 235.569H28.1653L32.9892 235.57H34.796L43.1765 235.57H45.0299L47.2336 235.57H47.264L47.2617 246.583",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0416 121.543L73.3907 121.543V119.125",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M74.007 76.1558H74.3352L74.3152 76.0958",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0416 119.125H73.3865L73.3851 118.833L73.3827 119.235V121.543",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9316 120.04H68.1605L68.1579 119.835L68.1555 119.235L68.1535 118.279L68.1505 121.543",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6462 70.3458L68.9702 70.3466L68.7159 70.3458L68.1926 70.1042L67.973 69.444L67.9692 69.4129L67.9057 68.8936L67.7215 67.388L67.5117 65.6719L60.994 12.3719L60.8936 11.5504L60.8058 10.8323L60.9554 9.98564L61.2789 9.56734L61.4394 9.22102L62.1358 8.80806L62.8853 9.0789L63.2184 9.56734L63.4702 9.82473L63.7096 10.6465L63.8202 11.5504L63.9206 12.3719L68.2465 47.7481",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5429 11.822V13.3249L50.538 13.3249L50.4732 13.3251V2.80385",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4732 13.3251H50.4683H48.2916V2.80385",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5854 2.80382L39.731 2.9632L39.722 2.96323L37.9088 3.48561M37.9088 3.48561L36.1755 4.35776L36.1665 4.35779L37.8999 3.48561H37.9088Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M58.483 8.06438H51.2311L51.2294 8.50462L51.2286 9.5674L51.2294 10.6302L51.2311 11.0704H58.483",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M60.994 12.3719H58.4866L58.4833 11.5505L58.483 11.0704L58.4827 10.6302L58.482 9.56743L58.4827 8.50462L58.483 8.06439L58.4833 7.58432L58.4866 6.76289L75.0416 6.76292",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2681 242.696L22.2641 242.696H16.747L16.747 236.732L16.751 236.732L22.2641 236.732L22.2681 236.732V242.696Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M29.705 243.918L29.705 236.472L29.713 236.472L44.6493 236.473L44.6573 236.472V243.918H29.705Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1.87654 258.533L1 258.234V256.382L1.87654 256.082",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1173 284.118H32.6805L32.6792 284.009L32.6779 283.694L32.677 283.202L32.6764 282.625",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2391 284.727L34.2385 284.093L34.238 282.625",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6712 294.136L34.6754 296.273L34.6852 298.798L34.6961 299.667H39.5697",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1629 123.068V119.6L22.2782 119.599L23.0043 119.6",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M13.794 234.275L15.4673 234.275L23.1483 234.276H25.0025L32.9856 234.276L34.905 234.276L43.1739 234.276H49.3857L48.9669 249.18L46.9143 249.047L44.2862 248.876L43.8715 248.839L43.2028 248.778L34.0895 247.949L33.7558 247.909L33.0229 247.824L23.9964 246.765L23.9223 246.757L23.1921 246.652L14.669 245.427L13.7917 245.301M13.794 234.275L13.7917 245.301M13.794 234.275H13.7438L13.7917 245.301M13.7917 245.301L13.8396 256.327L2.99265 243.29",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0415 266.768H53.656L51.5886 266.768H33.0462L29.164 266.768H23.2262L18.5896 266.768H8.58363L1.87653 266.768L4.32511 282.625L7.78549 285.901L8.26921 285.899H16.3903",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40687 157.526L9.43284 157.526L12.4513 234.275L3.40683 234.275L3.40687 157.526Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84436 123.071L6.84477 123.069L7.3285 123.068L8.38233 123.073L10.2772 123.068L20.446 123.071L20.5223 123.071H21.2762L21.3053 123.069L21.3434 123.069L21.3453 123.069L21.3469 123.069",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9316 121.543H73.3827L73.3907 121.543",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0109 69.4441L74.009 70.2717L74.0131 70.2722L74.012 70.1042L74.0109 69.4441Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M47.571 11.0704H39.6396L33.0925 19.2081V21.5916H31.0264L30.674 21.5916V17.963L38.6378 8.06432L47.571 8.06434",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8391 3.48582L37.8301 3.48585L36.0968 4.35803L36.1058 4.358L37.8391 3.48582ZM37.8391 3.48582L39.6523 2.96345H39.6612L41.5179 2.80387H50.5429L75.0416 2.8039",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8788 8.77852L31.9136 8.8158H31.9225L33.1446 7.05649L34.5741 5.55807L36.1755 4.3578",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2635 11.0704V11.8218L51.1988 11.822H50.4683",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1988 7.3129L51.2635 7.31272V8.06433",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7962 74.9739H72.3138L72.3131 75.15L72.3129 75.5751L72.3131 76.0002L72.3138 76.1763H72.7965",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0416 1.00008L41.5466 0.999962H41.5377L41.5355 1.00016L41.4769 1.00014L41.468 1.00016L39.4381 1.1738L37.3921 1.76037L35.4458 2.73968L33.6478 4.08738L32.0426 5.76988L30.7455 7.63721L31.8439 8.81592L31.8529 8.81589L31.8789 8.77844L33.0749 7.05658L34.5044 5.55816L36.1058 4.35793",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5117 65.672L67.5133 67.388L67.5158 68.8937L67.519 69.413H67.9692",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1652 244.388H28.1576V244.937L28.1652 244.937L28.5655 244.972H28.5819L33.0161 245.357L33.1171 245.364",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1483 234.276L17.3335 234.275H15.4673L15.0696 142.678L22.4871 142.678H22.8246L32.3805 142.678H32.7336L42.6258 142.678L42.9915 142.678H53.139L53.5143 142.678H64.2155L74.6222 142.678H75.0415",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7438 234.275L13.3461 142.678L13.3277 138.439H15.0512L22.8096 138.439L32.7219 138.439L42.9831 138.439L53.509 138.439L64.2133 138.439H75.0081H75.0415",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42202 123.073L13.3277 138.439L3.64932 132.893",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0415 117.511L74.8348 117.415L74.7225 117.222L74.4809 116.927L74.3516 116.335L74.35 115.714L74.3495 115.523",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4715 299.464H40.4575L40.4541 298.603L40.453 298.333L40.4527 298.234L40.4515 297.923L40.4513 297.889L40.4509 297.769L40.4492 297.352L40.4483 296.886L40.4476 296.526L40.4454 295.387L40.4445 294.958L40.4424 293.898",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4345 284.472L40.4344 284.161L40.434 282.989",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3867 114.919L73.3854 115.135L73.3847 115.241L73.3842 115.584",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3851 118.833L73.3827 118.279L73.384 118.136L73.3827 117.324L73.3837 117.222L73.3842 116.335L73.3833 116.122L73.3854 115.714L73.3842 115.584L73.3869 115.523",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0415 74.1236L74.732 74.2098L74.3775 74.5779L74.2697 74.9944",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7889 115.523L73.5925 115.445L73.3881 115.139L73.3854 115.135",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3277 138.439L9.5442 147.107L13.3933 244.979L1.87659 232.98",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M1.27762 242.61L2.81535 242.61L4.61794 243.29",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5624 284.755L33.5619 284.508L33.5607 283.27L33.5605 282.625",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3352 76.1558L74.3775 76.0958L74.3443 75.7307L74.2551 75.2745L74.2478 75.2526L74.2474 75.0807L74.2697 74.9944H74.0095L74.015 70.3459H74.584L74.5896 70.3466L74.5914 70.3459H75.0415",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0416 76.0385L74.7301 75.9517L74.3765 75.5836L74.2474 75.0808",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2409 114.919L72.6445 114.028L72.2644 113.531L72.0475 112.472L71.7795 111.316L71.7785 111.022L71.7744 109.777L71.7713 108.821L71.7693 108.221L71.7687 108.016H60.905L60.9025 108.221L60.9001 108.821L60.898 109.777L60.8964 111.022L60.8954 112.472L60.8951 114.028V121.543L68.046 121.544L68.1506 121.543L68.1705 121.543L71.9316 121.543V117.324L71.9318 117.034L71.9322 116.122L71.9331 115.584L71.9336 115.241L71.9356 114.919H73.3867L73.3881 115.139L73.3887 115.241L73.3892 115.523H74.3496L74.2501 76.1559L74.25 76.0958",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1535 118.279L68.1519 117.034L68.1509 115.584L68.1505 114.028L68.1509 112.472L68.1519 111.022L68.1535 109.777L68.1555 108.821L68.1579 108.221L68.1605 108.016",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1665 4.35783L34.5652 5.55809L33.1356 7.05652L31.9136 8.8158",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0968 4.35795L34.4955 5.55819L33.066 7.05661L31.8439 8.81592",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0416 51.3554L68.6876 51.3554L69.8336 60.7272L69.9124 61.3716L70.1277 63.1321L70.4218 65.537L70.5687 66.7386H69.9361L69.2493 66.9803L68.5831 67.6405L68.1159 68.5423L67.973 69.4441",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M105.434 236.473V243.918",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M127.819 236.732V242.696",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M113.3 245.68V245.682",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0726 68.5422L76.0722 67.6404",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0722 69.4441L76.0726 68.5423",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5452 11.8221V13.325",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M134.565 235.569V243.846",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M109.636 296.526H109.612",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M109.612 297.923H109.632",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8156 282.625V284.066",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M109.455 282.989L109.455 282.625",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M147.268 242.61V239.405",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M136.243 256.327L136.69 244.979",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M133.705 292.262L128.468 294.111",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M141.5 256.327V266.768",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6149 13.3251V7.31277",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M121.926 235.569L121.926 244.388",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0742 70.3466L76.0742 70.2716",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M121.918 244.937V235.57",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M107.824 246.154V246.152",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M108.429 246.102V246.1",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M112.768 245.725V245.727",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5402 7.31287V2.80378",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1625 12.3719H75.0416",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0416 60.7272H80.2495",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9127 121.543V120.04",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M125.999 235.569V244.585",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M141.814 285.899L141.966 285.755",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0416 285.899H83.2064",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6221 284.058V282.625",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M109.145 282.99V282.625",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M110.538 282.625L110.537 284.508",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M109.381 282.625L109.381 282.989",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M148.207 239.144V223.094",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M143.358 123.071L143.359 123.069",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0416 120.04H76.7004",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0416 66.7386H79.5144",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1881 118.078L126.904 118.078L127.079 118.078V123.069L108.76 123.073L108.541 123.071L82.0371 123.073V121.543",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6576 292.262L128.468 294.111L128.031 294.657L133.268 292.807L133.705 292.262L133.693 285.899L133.692 285.464L116.965 284.774L116.847 284.769L116.521 284.755L116.507 284.755L116.51 282.625",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M127.079 123.069L127.92 123.068L128.736 123.069L128.74 123.069",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M140.539 147.107L148.207 142.714L146.434 132.893L144.661 123.073L143.885 123.071L143.882 123.071L143.708 123.07L143.703 123.071",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0371 123.073H75.0416",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M116.507 284.755L116.175 284.741L115.844 284.727L115.703 284.722L115.421 284.71",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M108.76 123.073H108.541V121.543L108.511 121.543L89.188 121.543",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M107.739 284.393L105.544 284.302L99.8156 284.066L99.7669 284.064L99.761 284.064L99.7408 284.063L99.7303 284.063L99.6945 284.061L99.6665 284.06L99.6221 284.058L83.64 283.399L83.2025 283.944L83.2064 285.899L83.2201 292.808",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M136.244 266.768L134.827 282.625L125.142 282.625H117.377L116.967 282.625H94.9842L84.7018 282.625H75.0416",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M83.64 283.399L83.6576 292.262L83.2201 292.808L106.494 293.768L106.5 293.768L106.505 293.768L106.534 293.77L106.546 293.77L106.556 293.771L106.58 293.772L106.601 293.772L106.606 293.773L106.611 293.773L107.844 293.824L107.85 293.824L107.855 293.824L107.883 293.825L107.896 293.826L107.905 293.826L107.93 293.827L107.95 293.828L107.956 293.828L107.961 293.828L109.583 293.895L109.604 293.896L109.606 293.896L109.612 293.897L109.641 293.898L110.361 293.928L110.529 293.934L113.291 294.048L115.412 294.136L128.031 294.657",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M143.533 123.071L143.533 123.07L143.703 123.071H143.239L141.701 123.073",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M116.967 282.625L116.967 283.196V283.27L116.966 283.688V283.694L116.966 284.005L116.966 284.009L116.966 284.116V284.118L116.965 284.508L116.965 284.774",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M103.11 246.561L102.821 246.586V246.583L103.11 246.561ZM103.11 246.561L105.991 246.312L106.885 246.235L107.824 246.154L108.429 246.102L112.768 245.725L113.3 245.68L115.334 245.504H115.355L116.119 245.438L116.966 245.363V245.365",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M110.529 293.934L110.525 296.27V296.273L110.522 297.352L110.517 298.795V298.798L110.513 299.665L110.513 299.667L110.512 300.065L110.5 301H109.612L109.615 300.766",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0771 76.3522H77.2863L77.2866 76.1763L77.2869 76.0159V76.0002L77.2872 75.5751V75.5554L77.287 75.15L77.287 75.0793L77.2869 74.9739L77.2835 70.3459L77.2833 70.1042L77.2828 69.4441L77.2821 68.5423L77.2815 67.6404",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M109.6 299.464L109.6 299.842L109.6 300.065L109.601 300.111L109.606 300.532L109.608 300.668L109.609 300.766L109.612 301",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M109.574 282.625L109.574 282.685L109.574 282.989L109.575 284.293L109.575 284.469",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M143.318 123.069L143.318 123.071L143.238 123.069L143.318 123.069ZM143.318 123.069L143.347 123.071L143.359 123.069L143.525 123.071L143.533 123.07",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0416 47.7481H81.8366H82.4693L83.1559 47.9897L82.3867 48.4227L82.2794 48.6499L81.7825 49.3266L81.7277 49.5517L81.53 50.2556L81.5058 50.4535L81.425 51.1137L81.3955 51.3553",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M115.422 282.625L115.422 283.989L115.421 284.093L115.421 284.71L113.007 284.61L110.537 284.508L110.146 284.492L109.649 284.472L109.61 284.47L109.608 284.47L109.606 284.47L109.575 284.469L109.478 284.465L107.739 284.393V282.99H109.145L109.381 282.989H109.605",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M100.697 234.276L96.4546 234.276H94.4523L85.8205 234.276H75.0416",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2834 70.3459H78.437L78.3145 108.016",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M76.07 70.2722L76.0696 70.3459L76.0742 70.3466L76.0766 74.9944L76.0777 75.0793L76.0772 75.2745L76.0779 75.5554L76.0773 75.7307L76.0776 76.0159L76.0768 76.0958",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0777 76.0159L76.075 76.0958L76.0761 76.1558L76.0771 76.3522L76.0755 76.3834L76.0763 76.4852H77.2856L77.2863 76.3522",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M101.792 11.822H102.512V7.31284L102.447 7.3127L101.792 7.31287",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8843 11.822V7.31287H99.5402L99.5452 7.3127L99.6099 7.31287L99.6149 7.3127L99.6149 2.80378",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M145.465 238.726L147.245 238.725L148.207 239.144L148.805 239.405L147.268 239.405L145.465 238.726ZM145.465 238.726V243.29L147.09 243.29H147.245L148.207 242.871L148.207 256.082V266.768",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M145.758 282.625L134.827 282.625L141.966 285.755L142.298 285.901",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M148.806 239.405V242.61L148.207 242.871",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M148.207 226.79L148.458 226.084L148.459 226.046L148.459 225.931L148.46 225.75L148.46 225.513L148.46 225.238L148.46 224.942L148.46 224.647L148.46 224.371L148.46 224.135L148.459 223.953L148.459 223.839L148.458 223.8L148.207 223.094L148.206 142.714",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M109.611 282.989H109.649L109.649 282.625",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0416 256.327H75.1L75.1242 256.327L85.8091 256.327L86.8695 256.327L96.4271 256.327L98.4945 256.327L106.865 256.327L109.882 256.327L117.037 256.327L120.919 256.327L126.857 256.327L131.493 256.327L136.244 256.327L141.499 256.327L148.207 256.327",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M121.925 244.937L125.912 244.593L125.999 244.585L126.899 244.508L134.565 243.846H134.568L134.565 235.569L126.93 235.569H125.185L121.925 235.569H121.918L117.094 235.57H115.287L106.907 235.57H105.053L102.85 235.57H102.819L102.821 246.583",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0416 121.543L76.6925 121.543V119.125",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M76.076 76.1558H75.7479L75.7679 76.0958",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0416 119.125H76.6966L76.6981 118.833L76.7004 119.235V121.543",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1515 120.04H81.9226L81.9252 119.835L81.9275 119.235L81.9296 118.279L81.9325 121.543",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M78.437 70.3458L81.1129 70.3466L81.3672 70.3458L81.8905 70.1042L82.1101 69.444L82.1139 69.4129L82.1774 68.8936L82.3616 67.388L82.5714 65.6719L89.0891 12.3719L89.1895 11.5504L89.2773 10.8323L89.1277 9.98564L88.8042 9.56734L88.6437 9.22102L87.9473 8.80806L87.1978 9.0789L86.8647 9.56734L86.6129 9.82473L86.3735 10.6465L86.2629 11.5504L86.1625 12.3719L81.8366 47.7481",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5402 11.822V13.3249L99.5452 13.3249L99.6099 13.3251V2.80385",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6099 13.3251H99.6149H101.791V2.80385",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M108.498 2.80382L110.352 2.9632L110.361 2.96323L112.174 3.48561M112.174 3.48561L113.908 4.35776L113.917 4.35779L112.183 3.48561H112.174Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6001 8.06438H98.852L98.8537 8.50462L98.8545 9.5674L98.8537 10.6302L98.852 11.0704H91.6001",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0891 12.3719H91.5965L91.5998 11.5505L91.6001 11.0704L91.6004 10.6302L91.6011 9.56743L91.6004 8.50462L91.6001 8.06439L91.5998 7.58432L91.5965 6.76289L75.0416 6.76292",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M127.815 242.696L127.819 242.696H133.336L133.336 236.732L133.332 236.732L127.819 236.732L127.815 236.732V242.696Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M120.378 243.918L120.378 236.472L120.37 236.472L105.434 236.473L105.426 236.472V243.918H120.378Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M148.207 258.533L149.083 258.234V256.382L148.207 256.082",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M116.966 284.118H117.403L117.404 284.009L117.405 283.694L117.406 283.202L117.407 282.625",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M115.844 284.727L115.845 284.093L115.845 282.625",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M115.412 294.136L115.408 296.273L115.398 298.798L115.387 299.667H110.513",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M127.92 123.068V119.6L127.805 119.599L127.079 119.6",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M136.289 234.275L134.616 234.275L126.935 234.276H125.081L117.098 234.276L115.178 234.276L106.909 234.276H100.697L101.116 249.18L103.169 249.047L105.797 248.876L106.212 248.839L106.88 248.778L115.994 247.949L116.327 247.909L117.06 247.824L126.087 246.765L126.161 246.757L126.891 246.652L135.414 245.427L136.291 245.301M136.289 234.275L136.291 245.301M136.289 234.275H136.339L136.291 245.301M136.291 245.301L136.244 256.327L147.09 243.29",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0416 266.768H96.4271L98.4945 266.768H117.037L120.919 266.768H126.857L131.493 266.768H141.499L148.207 266.768L145.758 282.625L142.298 285.901L141.814 285.899H133.693",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M146.676 157.526L140.65 157.526L137.632 234.275L146.676 234.275L146.676 157.526Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M143.239 123.071L143.238 123.069L142.755 123.068L141.701 123.073L139.806 123.068L129.637 123.071L129.561 123.071H128.807L128.778 123.069L128.74 123.069L128.738 123.069L128.736 123.069",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1515 121.543H76.7004L76.6924 121.543",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0722 69.4441L76.0742 70.2717L76.0701 70.2722L76.0711 70.1042L76.0722 69.4441Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M102.512 11.0704H110.444L116.991 19.2081V21.5916H119.057L119.409 21.5916V17.963L111.445 8.06432L102.512 8.06434",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M112.244 3.48582L112.253 3.48585L113.986 4.35803L113.977 4.358L112.244 3.48582ZM112.244 3.48582L110.431 2.96345H110.422L108.565 2.80387H99.5402L75.0416 2.8039",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M118.204 8.77852L118.17 8.8158H118.161L116.939 7.05649L115.509 5.55807L113.908 4.3578",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8196 11.0704V11.8218L98.8843 11.822H99.6148",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8843 7.3129L98.8196 7.31272V8.06433",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2869 74.9739H77.7693L77.77 75.15L77.7703 75.5751L77.77 76.0002L77.7693 76.1763H77.2866",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0416 1.00008L108.536 0.999962H108.545L108.548 1.00016L108.606 1.00014L108.615 1.00016L110.645 1.1738L112.691 1.76037L114.637 2.73968L116.435 4.08738L118.04 5.76988L119.338 7.63721L118.239 8.81592L118.23 8.81589L118.204 8.77844L117.008 7.05658L115.579 5.55816L113.977 4.35793",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5714 65.672L82.5698 67.388L82.5673 68.8937L82.564 69.413H82.1139",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M121.918 244.388H121.925V244.937L121.918 244.937L121.518 244.972H121.501L117.067 245.357L116.966 245.364",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M126.935 234.276L132.75 234.275H134.616L135.014 142.678L127.596 142.678H127.258L117.703 142.678H117.35L107.457 142.678L107.092 142.678H96.9441L96.5688 142.678H85.8676L75.461 142.678H75.0416",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M136.339 234.275L136.737 142.678L136.755 138.439H135.032L127.273 138.439L117.361 138.439L107.1 138.439L96.5741 138.439L85.8698 138.439H75.075H75.0416",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M144.661 123.073L136.755 138.439L146.434 132.893",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0416 117.511L75.2483 117.415L75.3606 117.222L75.6022 116.927L75.7315 116.335L75.7331 115.714L75.7336 115.523",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M109.612 299.464H109.626L109.629 298.603L109.63 298.333L109.63 298.234L109.632 297.923L109.632 297.889L109.632 297.769L109.634 297.352L109.635 296.886L109.636 296.526L109.638 295.387L109.639 294.958L109.641 293.898",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M109.649 284.472L109.649 284.161L109.649 282.989",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6964 114.919L76.6977 115.135L76.6984 115.241L76.699 115.584",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6981 118.833L76.7004 118.279L76.6991 118.136L76.7004 117.324L76.6994 117.222L76.6989 116.335L76.6999 116.122L76.6978 115.714L76.699 115.584L76.6962 115.523",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0416 74.1236L75.3511 74.2098L75.7056 74.5779L75.8134 74.9944",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2942 115.523L76.4906 115.445L76.695 115.139L76.6977 115.135",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M136.755 138.439L140.539 147.107L136.69 244.979L148.207 232.98",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M148.805 242.61L147.268 242.61L145.465 243.29",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M116.521 284.755L116.521 284.508L116.522 283.27L116.523 282.625",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7479 76.1558L75.7056 76.0958L75.7388 75.7307L75.828 75.2745L75.8353 75.2526L75.8358 75.0807L75.8134 74.9944H76.0736L76.0681 70.3459H75.4991L75.4935 70.3466L75.4917 70.3459H75.0416",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0416 76.0385L75.353 75.9517L75.7067 75.5836L75.8358 75.0808",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8423 114.919L77.4386 114.028L77.8187 113.531L78.0356 112.472L78.3037 111.316L78.3047 111.022L78.3087 109.777L78.3118 108.821L78.3138 108.221L78.3145 108.016H89.1781L89.1807 108.221L89.1831 108.821L89.1851 109.777L89.1867 111.022L89.1877 112.472L89.1881 114.028V121.543L82.0371 121.544L81.9326 121.543L81.9127 121.543L78.1515 121.543V117.324L78.1514 117.034L78.151 116.122L78.1501 115.584L78.1495 115.241L78.1475 114.919H76.6964L76.6951 115.139L76.6944 115.241L76.694 115.523H75.7336L75.833 76.1559L75.8332 76.0958",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9296 118.279L81.9312 117.034L81.9322 115.584L81.9326 114.028L81.9322 112.472L81.9312 111.022L81.9296 109.777L81.9276 108.821L81.9252 108.221L81.9226 108.016",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M113.917 4.35783L115.518 5.55809L116.948 7.05652L118.17 8.8158",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M113.986 4.35795L115.588 5.55819L117.017 7.05661L118.239 8.81592",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0416 51.3554L81.3955 51.3554L80.2495 60.7272L80.1707 61.3716L79.9554 63.1321L79.6613 65.537L79.5144 66.7386H80.147L80.8338 66.9803L81.5 67.6405L81.9672 68.5423L82.1102 69.4441",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTram);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tram.8ab2927c908c69bf6b3b4d3e9e6adea9.svg";